import { render, staticRenderFns } from "./riderWiseRVPReport_KSA_new.vue?vue&type=template&id=67cc2294&"
import script from "./riderWiseRVPReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./riderWiseRVPReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports